import type { ReactPaginateProps } from 'react-paginate';

export interface PaginationData {
  pageCount: number;
  onChange?: (pageNumber: number) => void;
  forcePage?: number;
  initialPage?: number;
}

export interface PaginationProps extends ReactPaginateProps, PaginationData {}
